<template>
  <div style="display: contents;">
    <b-row>
      <b-col md="8">
        <h5 class="result-summary-flex"><translate>Booking general details</translate> <span class="text-dark border font-weight-bold rounded px-2 bg-ligth-brown float-right d-none d-sm-inline-block">{{ booking.id }}</span></h5>
        <table class="table table-striped border">
            <tr>
              <td><b><translate>Booking date</translate>:</b> {{ getDate(booking.booking_date, 'DD-MM-YYYY') }}</td>
              <td><b><translate>Booking value</translate>:</b> {{ booking.currency }} {{ bookingTotal  }} </td>
            </tr>
            <tr>
              <td><b><translate>Booking reference</translate>:</b> {{ booking.id}}</td>
              <td><b><translate>Commission</translate>:</b> {{ booking.currency }} {{ round(booking.commission) }}</td>
            </tr>
            <tr>
              <td><b><translate>Booking status</translate>:</b> {{ booking.status}}</td>
              <td><b><translate>Total amount due</translate>:</b> {{ booking.currency }} {{ bookingTotalDue }}</td>
            </tr>
            <tr>
              <td><b><translate>Destination</translate>:</b> {{ booking.destination }}</td>
              <td><b><translate>Paid</translate>:</b> {{ booking.currency }} {{ round(booking.paid )}}</td>
            </tr>
            <tr>
              <td><b><translate>Agent</translate>:</b> {{ booking.user }}</td>
              <td><b><translate>Balance due</translate>:</b> {{ booking.currency }} {{ bookingUnpaid }}</td>
            </tr>
            <tr>
              <td >
                <b><translate>Agency</translate>:</b> {{ userData.companyName }}
              </td>
              <td>
                <b><translate>Invoices</translate>:</b>
                <span v-if="!booking.invoices.length"> n/a</span>
                <a @click="downloadInvoice(invoice)" v-for="invoice in booking.invoices" :key="invoice.id" class="link">
                  <span class="invoice"> <b-icon icon="download" class="mx-2 font-weight-bold"/>{{ invoice.number }}</span><br />
                </a>
              </td>
            </tr>
            <tr>
              <td><b><translate>Due dates</translate>:</b> </td>
              <td>
                <span v-for="(d,dIndex) in booking.due_dates" :key="'dueDate'+dIndex">{{ booking.currency }} {{ d.amount }} pana la {{ d.date }}<br /></span>
                <translate>difference up to</translate>{{ booking.balance_due_date }}
              </td>
            </tr>
        </table>
        <b-card class="p-2" no-body="">
          <b><translate>Agent notes</translate>:</b>
          <span v-for="(note, index) in booking.notes" :key="index" style="white-space: pre-line;">
            {{note.text}}
          </span>
        </b-card>
      </b-col>
      <b-col md="4" class="my-3 my-md-0">
        <h5 class="result-summary-flex" v-translate>Passengers</h5>
        <table class="table table-striped table-sm border">
          <tbody>
            <tr v-for="(pax, paxIndex) in booking.pax" :key="paxIndex">
              <td><span class="small text-">{{pax.title + ' ' + pax.fname + ' ' + pax.lname}}</span>
              <span class="badge float-right"> {{ pax.ageGroup }} / {{ getDate(pax.bdate) }} </span></td>
            </tr>
          </tbody>
        </table>
        <h5 class="package-title bg-ligth-brown p-2" v-translate>Files attached</h5>
        <table class="table table-sm border">
          <tbody>
            <tr v-for="(file, fileIndex) in booking.attachments" :key="fileIndex">
              <td colspan="2">{{ file.title }} &ndash;
                <a :href="file.url">{{ file.filename }}</a></td>
            </tr>
            <tr>
              <td>
                <b-form-file
                  size="sm"
                  v-model="file"
                  accept=".pdf"
                  :placeholder="$gettext('Choose a PDF file...')"
                  drop-placeholder="Drop a PDF file here..."
                ></b-form-file>
              </td>
              <td>
                <b-button @click="onUploadClick()" size="sm" v-translate>Send</b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <b-row class="my-3">
      <b-col>
        <hr />
      </b-col>
    </b-row>
    <b-row v-for="item in booking.items" :key="'item' + item.id">
      <b-col>
        <PackageItem :item="item" v-if="item.type === 'sd_package'" />
        <FlightItem :item="item" v-else-if="item.type === 'flight'" />
        <TransferItem :item="item" v-else-if="item.type === 'transfer'" />
        <HotelItem :item="item" v-else-if="item.type === 'hotel'" />
        <InsuranceItem :item="item" v-else-if="item.type === 'insurance'" />
        <div v-else>
          <h6 class="booking-details-title">{{ item.label }}</h6>
          <b-card bg-variant="light">
            <b-card-text style="white-space: pre-line;">
              {{ item.description }}
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <hr>
      </b-col>
      <b-col>
        <b-button variant="primary" size="sm" class="float-right" @click="$router.push({ name: 'Private/Bookings/Search' })"><b-icon icon="chevron-left" />Back to results</b-button>
      </b-col>
    </b-row>
    <!-- {{ booking.id }} -->
  </div>
</template>

<script>
import moment from 'moment'
import http from 'b2b-common/vue-config/axios'

import { authApiURL } from 'b2b-common/utils'
import { getInvoice, downloadPdf } from 'b2b-common/services/api/document'

import authMixin from 'b2b-common/mixins/auth'

import PackageItem from './package_item_info'
import TransferItem from './transfer_item_info'
import FlightItem from './flight_item_info'
import HotelItem from './hotel_item_info'
import InsuranceItem from './insurance_item_info'
import { round } from '@/shared/utils'

export default {
  name: 'bookingDetails',
  props: ['booking'],
  mixins: [authMixin],
  components: { PackageItem, TransferItem, FlightItem, InsuranceItem, HotelItem },
  data () {
    return {
      file: null,
      round: round
    }
  },
  computed: {
    bookingTotal () {
      const n = parseFloat(this.booking.gross) + parseFloat(this.booking.tax)
      return Math.ceil(n * 100) / 100
    },
    bookingTotalDue () {
      const n = parseFloat(this.booking.gross) + parseFloat(this.booking.tax) - parseFloat(this.booking.commission)
      return Math.ceil(n * 100) / 100
    },
    bookingUnpaid () {
      const n = parseFloat(this.booking.gross) + parseFloat(this.booking.tax) - parseFloat(this.booking.commission) - parseFloat(this.booking.paid)
      return Math.ceil(n * 100) / 100
    }
  },
  methods: {
    getDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    async onUploadClick () {
      const formData = new FormData()
      formData.append('file', this.file)
      const res = await http.post(authApiURL,
        formData,
        {
          params: {
            action: 'attachBookingFile',
            id: this.booking.id
          },
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      this.booking.attachments.push(res.data)
      return res.data
    },
    async downloadInvoice (invoice) {
      const pdfData = await getInvoice({ bookingId: this.booking.id, invoiceId: invoice.id })
      const fileName = 'factura_' + invoice.number + '.pdf'
      downloadPdf({ pdfData: pdfData.pdf, fileName })
    }
  }
}
</script>
<style scoped>
  a.link:hover{
    text-decoration: none;
    color: hsl(213, 66%, 15%);
  }
  .invoice{
    color: hsl(213, 66%, 50%);
    font-weight: 900;
    font-size: 1.1rem;
    cursor: pointer;
    border-bottom:2px solid hsl(213, 66%, 50%);
  }
</style>
